import * as Yup from "yup";
const createProfile2ValidationSchema = Yup.object({
  bank_name: Yup.string().required("Bank name is required"),
  beneficiary: Yup.string().required("Beneficiary is required"),
  signatories: Yup.string().required("Signatories is required"),
  account_number: Yup.number().required("Account number is required"),
});

export { createProfile2ValidationSchema };
